import { Navigate, Route, Routes } from 'react-router-dom';
import { Alert, Button, EmptyState } from '@tb/ui';
import { useSession } from './auth/SessionProvider';
import { BootSplash } from './components/Boot';
import { Screen } from './components/Layout';
import { useT } from './i18n/LocaleProvider';
import { ChangeTemplateScreen } from './screens/ChangeTemplateScreen';
import { HomeScreen } from './screens/HomeScreen';
import { PlansScreen } from './screens/PlansScreen';
import { NewSiteScreen } from './screens/NewSiteScreen';
import { SiteScreen } from './screens/SiteScreen';
import { EditorScreen } from './screens/EditorScreen';
import { PublishScreen } from './screens/PublishScreen';
import { VersionsScreen } from './screens/VersionsScreen';
import { useRuntimeConfig } from './RuntimeConfigProvider';
import { openExternal } from './telegram/telegram';

export function App() {
  const session = useSession();
  const config = useRuntimeConfig();
  const t = useT();

  if (session.status === 'loading') return <BootSplash />;

  if (session.status === 'outside') {
    return (
      <Screen>
        <div className="tb-screen">
          <EmptyState
            icon="telegram"
            title={t('session.outside.title')}
            description={t('session.outside.body')}
            action={
              <Button icon="telegram" onClick={() => openExternal(config.botUrl)}>
                {t('session.outside.button')}
              </Button>
            }
          />
        </div>
      </Screen>
    );
  }

  if (session.status === 'error') {
    return (
      <Screen>
        <div className="tb-screen">
          <Alert tone="danger" title={t('session.failed')}>
            {session.message}
          </Alert>
          <Button icon="refresh" onClick={() => window.location.reload()}>
            {t('boot.retry')}
          </Button>
        </div>
      </Screen>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<HomeScreen />} />
      <Route path="/new/:domain" element={<NewSiteScreen />} />
      <Route path="/sites/:siteId" element={<SiteScreen />} />
      <Route path="/sites/:siteId/edit" element={<EditorScreen />} />
      <Route path="/sites/:siteId/publish" element={<PublishScreen />} />
      <Route path="/sites/:siteId/versions" element={<VersionsScreen />} />
      <Route path="/sites/:siteId/template" element={<ChangeTemplateScreen />} />
      <Route path="/plans" element={<PlansScreen />} />
      <Route path="/plans/:siteId" element={<PlansScreen />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
